<template>
  <CockpitDialog
    title="任务详情"
    :top="'150px'"
    :left="'500px'"
    :width="'1000px'"
    :height="'600px'"
    @close="close"
  >
    <el-table
      v-loading="tableLoading"
      :data="tableData"
      height="450px"
      highlight-current-row
    >
      <el-table-column prop="viewpointName" label="巡检对象名称"></el-table-column>
      <el-table-column prop="createTime" label="识别时间"></el-table-column>
      <el-table-column prop="identifyType" label="识别类型">
        <template slot-scope="scope">{{ typeMap[scope.row.identifyType] || scope.row.identifyType }}</template>
      </el-table-column>
      <el-table-column prop="deviceResult" label="识别结果"></el-table-column>
      <el-table-column prop="cameraPhotoPath" label="采集信息">
        <template slot-scope="scope">
          <div v-if="scope.row.cameraPhotoPath" @click="imageClick(scope.row)">
            <img :src="scope.row.cameraPhotoPath" class="w-40px h-40px">
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-10px flex justify-center"
      background
      @current-change="currentChange"
      @size-change="sizeChange"
      :current-page="initPagination.pageNum"
      :page-size="initPagination.pageSize"
      layout="total, prev, pager, next"
      :total="initPagination.total"
      :pager-count="5"
    >
    </el-pagination>

    <el-image
      v-show="false"
      ref="elImage"
      :src="cameraPhotoPath"
      :preview-src-list="[cameraPhotoPath]"
    ></el-image>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import robotService from '../../../../service/RobotService'

export default {
  name: 'TaskDetailDialog',
  components: {
    CockpitDialog,
  },
  props: {
    robotHost: {
      type: String,
      default: null,
    },
    detailInfo: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      cameraPhotoPath: '',
      typeMap: {
        1: '仪表识别',
        2: '音频分析',
        3: '红外测温',
        4: '局放检测',
        5: '可见光拍照',
        6: '热像仪拍照',
        7: '可见光录像',
        8: '热像仪录像',
        9: '甲烷遥测',
        10: '录音',
        11: '人员入侵检测',
        12: '安全帽检测',
        13: '三项测温',
        14: '状态一致性',
        15: '部队队列识别',
        16: '车辆违停识别',
        17: '军装穿戴检测',
        18: '异物检测',
        19: '皮带跑偏',
        20: '托辊脱落检测',
        21: '末端工业相机拍照',
        22: '局放检测-特高频',
        23: '局放检测-超声波',
        24: '局放检测-地电波',
        25: '明火检测',
        26: '烟雾识别',
        27: '液体滴漏',
        28: '漏气识别',
        29: '电缆掉落识别',
        30: '可逆胶带机漏油识别',
        31: '可逆胶带机托辊脱落识别',
        32: '防火泥封堵脱落识别',
        33: '电缆移出桥架外侧识别',
        34: '防毒口罩检测',
        35: '防护服检测',
        36: '撒料检测',
        37: '皮带边缘破损',
        38: '充电桩外壳绝缘检测',
        39: '充电桩显示屏故障检测-触碰',
        40: '充电桩显示屏故障检测-识别',
        41: '充电桩外观形体检测',
        42: '充电桩外皮破损检测',
        43: '燃油车占位识别'
      }
    }
  },
  methods: {
    currentChange(val) {
      this.initPagination.pageNum = val
      this.getList()
    },
    sizeChange(val) {
      this.initPagination.pageSize = val
      this.initPagination.pageNum = 1
      this.getList()
    },
    imageClick(item) {
      this.cameraPhotoPath = item.cameraPhotoPath
      this.$nextTick(() => {
        this.$refs.elImage.clickHandler()
      })
    },
    async getList() {
      this.tableLoading = true
      const [err, res] = await robotService.getRobotTaskDetail(this.robotHost, {
        pageNum: this.initPagination.pageNum,
        pageSize: this.initPagination.pageSize,
        robotId: 1,
        execId: this.detailInfo.execId,
      })
      if (!err && res && res.data && res.data.list) {
        res.data.list.forEach((item) => {
          if (item.cameraPhotoPath) {
            const arr = item.cameraPhotoPath.split('.')
            if (arr.length > 1) {
              // 按最后一个 "/" 分割路径
              const parts = arr[0].split('/')
              const lastPart = parts[parts.length - 1]
              const beforePart = parts.slice(0, parts.length - 1).join('/')
              const basePart = `${beforePart}/${encodeURIComponent(lastPart)}.${arr[1]}`
              item.cameraPhotoPath = `${this.robotHost}${basePart}`
            } else {
              item.cameraPhotoPath = `${this.robotHost}${item.cameraPhotoPath}`
            }
          }
          if (item.vpApparatusRecordList?.length) {
            item.identifyType = item.vpApparatusRecordList[0].identifyType
            item.deviceResult = item.vpApparatusRecordList[0].deviceResult
          }
        })
        this.tableData = res.data.list
        this.initPagination.total = res.data.total
      }
      this.tableLoading = false
    },
    close() {
      this.$emit('close')
    },
  },
  created() {
    this.getList()
  }
}
</script>
